const customerModel = {
  id: null,
  name: null,
  addressLine1: null,
  addressLine2: null,
  zip: null,
  city: null,
  taxNumber: null,
  isPoz: false,
  addresses: [],
}
export default {
  customerEdited: customerModel,
  customerModel,
  customers: [],
}
